import React from "react";
import PropTypes from "prop-types";

const SubformList = ({
  name,
  newElementAdded,
  elements,
  className,
  onChange,
  elementComponent: ElementComponent,
  elementComponentProps,
  remove,
  push,
  form,
}) => {
  const handleDelete = (remove, index) => () => {
    remove(index);
  };

  return elements && elements.length > 0
    ? elements.map((element, index) => (
        <div key={element.id || index}>
          <ElementComponent
            index={index}
            collectionName={name}
            element={element}
            newElementAdded={newElementAdded}
            onChange={onChange}
            onDelete={handleDelete(remove, index)}
            form={form}
            sortable={false}
            {...elementComponentProps}
          />
        </div>
      ))
    : null;
};

SubformList.propTypes = {
  /**
   * Nombre del array que contiene los elementos del subformulario
   */
  name: PropTypes.string.isRequired,
  /**
   * Indica si se ha creado un elemento recientemente
   */
  newElementAdded: PropTypes.any,
  /**
   * Array con los elementos del subformulario
   */
  elements: PropTypes.array,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Callback que se llama al cambiar el estado del formulario compuesto
   */
  onChange: PropTypes.func,
  /**
   * Componente que renderiza un elemento a su representación en formulario
   */
  elementComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  /**
   * Props adicionales para el componente del elemento
   */
  elementComponentProps: PropTypes.object,
  /**
   * Función para borrar el elemento del listado
   */
  remove: PropTypes.func,
  /**
   * Función para añadir un elemento al listado
   */
  push: PropTypes.func,
  /**
   * Estado y helpers de Formik
   */
  form: PropTypes.object,
};

export default SubformList;
